import { Divider, Skeleton } from '@heroui/react';
import { LazyImage } from '@ui/common/lazy-image.tsx';
import { OrderStatus, OrderStatusProps } from '@ui/order/order-status';

export type OrderCardProps = {
  variant?: 'primary' | 'secondary';
  number?: string;
  date?: string;
  total?: string;
  isLoading?: boolean;
  status?: OrderStatusProps['variant'];
  images?: (string | undefined)[];
  onPress?: () => void;
};

export const OrderCard = ({
  variant = 'primary',
  status,
  number = '#123456',
  isLoading = false,
  onPress,
  date = '11.06.2025',
  total = '35 300 ₸',
  images = [],
}: OrderCardProps) => {
  const wrapperClassName =
    variant === 'primary'
      ? 'w-full py-4 snap-center'
      : 'w-[270px] h-[168px] snap-center flex flex-col rounded-xl border-2 lg:border lg:w-full border-[#EAEAEB] p-4 flex-shrink-0';

  return (
    <div className={wrapperClassName} onClick={onPress}>
      <div className="flex flex-row items-center justify-between">
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <p className="text-[#222222] text-sm font-semibold">{number}</p>
        </Skeleton>

        <OrderStatus variant={status} isLoading={isLoading} />
      </div>

      <div className="flex flex-row items-center justify-between lg:justify-start gap-x-3.5 my-4">
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <div className="flex flex-row items-center justify-between gap-x-1">
            <p className="text-sm text-[#6B767F]">Дата:</p>
            <p className="text-sm text-[#222222]">{date}</p>
          </div>
        </Skeleton>

        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <div className="flex flex-row items-center justify-between gap-x-1">
            <p className="text-sm text-[#6B767F]">Сумма:</p>

            <p className="text-sm text-[#222222]">{total}</p>
          </div>
        </Skeleton>
      </div>

      <Divider className="bg-[#F8F9FA]" />

      <div className="flex flex-row items-center gap-x-3 mt-4">
        {images?.map((image, index) => {
          return (
            <div key={index} className="w-12 h-12">
              <LazyImage src={image || '/product_placeholder.jpg'} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
